import { makeStyles } from '@fluentui/react-components';

export const useHealthDashboardPageStyles = makeStyles({
    section: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        gap: '16px',
        padding: '16px',
    },
    toolbar: {
        justifyContent: 'end',
    },
    tile: {
        minWidth: '300px',
        maxWidth: '500px',
    },
    spinner: {
        position: 'absolute',
        minWidth: '100%',
        top: '50%',
    },
});
